import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {useEffect, useRef} from "react";
import {summaryAction, toggleAction} from "../../redux/store";
import callPeerRemoteModule from "../../../core/utils/callPeerRemoteModule";
import {elementReady} from "../../../core/utils/tools";


const useTakeScreenShot = () => {
  const {
    configId,
    screenShotCode,
    screenShotReady,
    screenShotActiveIndex,
    connectMode,
    currentHeader,
    loadingState,

  } = useSelector(state => ({
    configId: state.qrcode.configId,
    screenShotCode: state.summary.screenShotCode,
    screenShotReady: state.summary.screenShotReady,
    screenShotActiveIndex: state.summary.screenShotActiveIndex,
    connectMode: state.theme.connectMode,
    currentHeader: state.optionWindow.currentHeader,
    loadingState: state.intro.loadingState,
  }), shallowEqual);

  const screenShot = useSelector(state => state.summary.screenShot);
  const dispatch = useDispatch();
  const summaryImageElement = useRef();



  useEffect(() => {
    if (connectMode === "mediaWall" || loadingState !== "end") {
      return;
    }

    if (screenShotCode) {
      if (configId === screenShotCode) {
        return;
      } else {
        dispatch(summaryAction.setScreenShotReady(false));
        dispatch(summaryAction.clearScreenShot());
        return;
      }
    }


    dispatch(summaryAction.setScreenShotReady(false));
    // dispatch(summaryAction.clearScreenShot());

    (async () => {
      const peer = await callPeerRemoteModule(connectMode);
      if(peer) {
        peer.conn.sendData("dispatch", {action: "summaryAction", func: "setScreenShotReady", payload: false});
        peer.conn.sendData("dispatch", {action: "summaryAction", func: "clearScreenShot", payload: ""});
      }
    })();





    const captureWidth = summaryImageElement.current.clientWidth;
    const captureHeight = summaryImageElement.current.clientHeight;

    if (connectMode === "web") {
      window && window.postMessage({msg: "hotspot", data: false}, '*');
    }


    setTimeout(() => {
      if (connectMode === "web") {
        elementReady("#application-canvas").then(() => {
          window && window.postMessage({
            msg: 'ui:takeScreenshot', data: {width: captureWidth, height: captureHeight}
          }, '*');
        });

      }

      (async () => {
        const peer = await callPeerRemoteModule(connectMode);
        if(peer) {
          peer.conn.sendData('ui:takeScreenshot', {width: captureWidth, height: captureHeight});
          dispatch(toggleAction.resetMovingPartsState());
        }
      })();
    }, 400);
  }, [currentHeader, loadingState, screenShotCode]);


  useEffect(() => {
    if (connectMode === "mediaWall") {
      return;
    }

    if (screenShotCode === "" || configId !== screenShotCode) {
      return;
    }


    if (screenShot.length > 0) {
      dispatch(summaryAction.setScreenShotReady(true));

      (async () => {
        const peer = await callPeerRemoteModule(connectMode);
        if(peer) {
          peer.conn.sendData("dispatch", {action: "summaryAction", func: "setScreenShotReady", payload: true});
        }
      })();
    }
  }, [screenShot, screenShotCode]);



  return {
    connectMode, screenShot, screenShotActiveIndex, summaryImageElement, screenShotReady
  }
}

export default useTakeScreenShot;
